import axios from '@/common/utils/axios'
import type { Country } from '@/types/models'

export default {
  findAll(): Promise<{ data: Country[] }> {
    return axios.get('/xhr/country')
  },
}
